<template>
    <div class="tables-basic">

        <div v-if="loading" class="page-loading-container">
            <b-spinner label="Loading..." ></b-spinner>
        </div>
        <div v-else-if="crawlVersion < 1">
            <span style="color:gray">This report was generated with an older version of pagewatch.</span>
        </div>
        <div v-else>

            <h1 class="page-title"> Lighthouse Scores Across All Pages </h1>
            <b-alert v-if="!scanStatus.completed" show variant="primary"><b-spinner label="Loading..." style="width:16px;height:16px"></b-spinner> Check in progress.<br>
                Results will show up here automatically</b-alert>

            <Widget>
            <b-row>
                <b-col  lg="12">
            <trend-graph :clickable="true" :height="180" :options="trends.performance"></trend-graph>

                </b-col>
            </b-row>
            </Widget>
            <b-row>
                <b-col>
            <div class="float-right" id="top">
                <b-pagination-nav
                        v-model="currentPage"
                        :link-gen="linkGen()"
                        use-router
                        :number-of-pages="numberOfPages"
                        base-url="#"
                        first-number
                        last-number
                        align="right"
                ></b-pagination-nav>
            </div>
                </b-col>
            </b-row>
        <Widget  :title="selectedCrawlDate">
            <div class="table-responsive">
            <table class="table table-hover  table-sortable" >
                <thead>
                <tr>
                    <th scope="col" class="asc">Page</th>
                    <th scope="col" class="desc">Performance</th>
                    <th scope="col">SEO</th>
                    <th scope="col">Practices</th>
                    <th scope="col">Accessibility</th>
                    <th scope="col">Details</th>

                </tr>
                </thead>
                <tbody>
                <tr v-for="report in lighthouseReports">
                    <td class="report-link-entry">
                        <a :href="report.url" target="_blank" title="External Link">{{report.url}}</a>
                    </td>
                    <td>
                        <vc-donut :thickness="20" :size="30" :auto-adjust-text-size="false" :sections="[{ value: report.performance , color:lighthouseColor(report.performance, true)},]" :background="lighthouseColor(report.performance)" :foreground=lighthouseColor(report.performance)>
                            <span style="font-size:9pt">{{report.performance}}</span></vc-donut>

                    </td>
                    <td>                        <vc-donut :thickness="20" :size="30" :auto-adjust-text-size="false" :sections="[{ value: report.seo , color:lighthouseColor(report.seo, true)},]" :background="lighthouseColor(report.seo)" :foreground=lighthouseColor(report.seo)>
                        <span style="font-size:9pt">{{report.seo}}</span></vc-donut>
                    </td>
                    <td>                        <vc-donut :thickness="20" :size="30" :auto-adjust-text-size="false" :sections="[{ value: report.best_practices , color:lighthouseColor(report.best_practices, true)},]" :background="lighthouseColor(report.best_practices)" :foreground=lighthouseColor(report.best_practices)>
                        <span style="font-size:9pt">{{report.best_practices}}</span></vc-donut>
                    </td>
                    <td>                        <vc-donut :thickness="20" :size="30" :auto-adjust-text-size="false" :sections="[{ value: report.accessibility , color:lighthouseColor(report.accessibility, true)},]" :background="lighthouseColor(report.accessibility)" :foreground=lighthouseColor(report.accessibility)>
                        <span style="font-size:9pt">{{report.accessibility}}</span></vc-donut>
                    </td>
                    <td style="white-space: nowrap; vertical-align: middle;">
                        <router-link :to="{ name: 'ExplorePageDetails', query: {url: report.path} }" v-b-tooltip.hover  title='Page Details' ><i class="fa fa-eye"></i> Details</router-link>
                    </td>
                </tr>
                </tbody>

            </table>
            </div>
        </Widget>
        <div class="float-right">
            <b-pagination-nav
                    v-model="currentPage"
                    :link-gen="linkGen()"
                    use-router
                    :number-of-pages="numberOfPages"
                    base-url="#"
                    first-number
                    last-number
                    align="right"
            ></b-pagination-nav>
        </div>
    </div>
    </div>
</template>

<script>
  import axios from "axios";
  import { ApolloClient } from "apollo-client";
  import gql from "graphql-tag";
  import Widget from '@/components/Widget/Widget';
  import DemoNotice from "@/components/DemoNotice/DemoNotice";

  import { mapState } from "vuex";
  import TrendGraph from "@/components/TrendGraph/TrendGraph";

  export default {
    name: 'Subscriptions',
    components: { Widget, TrendGraph, DemoNotice },
    data(){
      return {
        trends: {
          performance: {
            series:[],
            categories: [],
            categoryParams: [],
          }
        },
        selectedCrawlId: null,
        selectedCrawlDate: null,
        crawlVersion: 2,
        loading: true,
        dataLoaded: false,
        lighthouseReports: [],
        fullLighthouseReports: [],
        currentPage: 1,
        numberOfPages: 1,
        pageCount: 1,
        pageSize: 15,
        subscriptionActive: true,
      }
    },
    apollo: {
      $subscribe: {
        trends: {
          query() {
            return gql`subscription {
                  trends:websites_website(where: {id: {_eq: ${this.activeSite.id}}}) {
                    websites_crawls(order_by: {started_at: desc}) {
                      id
                      started_at
                      websites_trends(where: {name: {_eq: "performance_lighthouse"}}) {
                        id
                        name
                        data_summary
                      }
                    }
                }
          }`
          },
          skip () {
            return !this.activeSite.id || (this.dataLoaded && this.scanStatus.completed);
          },
          result (data) {
            this.trends = {
              performance: {
                  series:[
                    {
                        name: 'Performance',
                        data:[],
                    },
                    {
                      name: 'SEO',
                      data:[],
                    },
                    {
                      name: 'Best Practices',
                      data:[],
                    },
                    {
                      name: 'Accessibility',
                      data:[],
                    },
                  ],
                  categories: [],
                  categoryParams: [],
                },
            };
            if (!this.selectedCrawlId){
              this.selectedCrawlId = data.data.trends[0].websites_crawls[0].id;
            }

            data.data.trends[0].websites_crawls.reverse()
            for (let entry of data.data.trends[0].websites_crawls){
              if (!(entry.websites_trends && entry.websites_trends[0])){
                continue
              }
              this.trends.performance.series[0].data.push(entry.websites_trends[0].data_summary.performance.median || 0)
              this.trends.performance.series[1].data.push(entry.websites_trends[0].data_summary.seo.median || 0)
              this.trends.performance.series[2].data.push(entry.websites_trends[0].data_summary.best_practices.median || 0)
              this.trends.performance.series[3].data.push(entry.websites_trends[0].data_summary.accessibility.median || 0)
              this.trends.performance.categories.push(entry.started_at)
              this.trends.performance.categoryParams.push(entry.id)
            }
          },
        },


        lighthouse_reports_aggregate: {
          query() {
            return gql`subscription {
                websites_lighthousereport_aggregate(where: {websites_devicerender: {websites_device: {id: {_eq: "galaxy_s6"}},  websites_crawledpage: {is_latest: {_eq: true}, website_id: {_eq: ${this.activeSite.id}}}}}){
                  aggregate {
                    count
                  }
                }
            }`
        },
          skip () {
            return !(this.activeSite && this.selectedCrawlId) || !this.subscriptionActive;
          },
          result (data) {
            this.numberOfPages = Math.ceil(data.data.websites_lighthousereport_aggregate.aggregate.count / this.pageSize);

            if (this.numberOfPages && this.currentPage > this.numberOfPages) {
              this.$router.push({ name: "PerformanceReportsPage" });
            }
            this.loading = false;
          }
        },
        selectedTrend: {
          query() {
            return gql`subscription {
            selectedTrend:websites_crawl(where: {id: {_eq: ${this.selectedCrawlId}}}){
                id
                started_at
                completed_at
                websites_trends(where:  {name: {_eq: "performance_lighthouse"}}){
                  id
                  websites_trend_pages_aggregate{
                    aggregate{
                      count
                    }
                  }
                  websites_trend_pages{
                    id
                    websites_crawledpage{
                      id
                      url
                      path
                      websites_devicerenders(where: {device_id: {_eq: "galaxy_s6"}}){
                        id
                        websites_lighthousereport{
                          id
                          performance
                          seo
                          best_practices
                          accessibility
                        }
                      }
                    }
                  }
                }
            }
          }`
          },
          skip () {
            return !(this.activeSite && this.selectedCrawlId) || (this.dataLoaded && this.scanStatus.completed);
          },
          result (data) {
            this.fullLighthouseReports = [];

            this.selectedCrawlDate = this.$moment(data.data.selectedTrend[0].started_at).format('MMM D hh:mma');


            for (let page of data.data.selectedTrend[0].websites_trends[0].websites_trend_pages){
              let report = page.websites_crawledpage.websites_devicerenders[0].websites_lighthousereport;
              this.fullLighthouseReports.push({
                performance: report.performance,
                best_practices: report.best_practices,
                accessibility: report.accessibility,
                seo: report.seo,
                url: page.websites_crawledpage.url,
                path: page.websites_crawledpage.path,
              })
            }
            this.fullLighthouseReports.sort((a, b) => a.performance - b.performance);
            this.paginateReports();

            // this.selectedCrawlDate = this.$moment(data.data.crawl_date[0].completed_at).format('MMM D hh:mma');
          },
        },
      }
    },
    computed: {
      ...mapState({ activeSite: "activeSite", scanStatus: "scanStatus", user: "user" })
    },
    methods: {
      paginateReports(){
        this.numberOfPages = Math.floor(this.fullLighthouseReports.length / this.pageSize) + 1;
        this.lighthouseReports = this.fullLighthouseReports.slice((this.currentPage-1) * this.pageSize, (this.currentPage) * this.pageSize)

      },
      linkGen(hash) {
        if (!hash){
          hash = '';
        }
        return (pageNum) =>{
          return pageNum === 1 ? `?${hash}` : `?page=${pageNum}${hash}`
        };
      },
      lighthouseColor(value, line=false){
        if (value < 50) {
          if (line) {
            return '#FF4E42';
          } else {
            return '#FFEEEC';
          }
        }
        if (value < 90) {
          if (line) {
            return '#FFA400';
          } else {
            return '#FFF6E6';
          }
        }
        if (line) {
          return '#67E0A2';
        } else {
          return '#E7FAF0';
        }
      },
    },
    watch: {
      'activeSite': function () {
        this.dataLoaded = false;
      }
    },
    mounted() {
    },
    created() {
      this.$watch("$route",() => {
        this.currentPage = this.$route.query.page || 1;
        if (this.$route.query.c){
          this.selectedCrawlId = this.$route.query.c;
        }
        this.paginateReports();
        this.subscriptionActive = true;
        }, {
        immediate: true
      });
    }
  };
</script>

<style lang="scss">
    .report-link-entry{
        max-width:400px;
        overflow:auto;
    }
</style>
